/**
 * Sidebar Footer
 *
 * @since 1.0.0
 */

export { SidebarFooter } from './component';
